import axios from 'axios'
import helpers from "@/helpers"
import Vue from 'vue'
import router from "@/router";

export default {
    storeInvitation({commit}, user) {
        axios.post(process.env.VUE_APP_API_URL + '/invitation', user)
            .then((response) => {
                helpers.handleSuccessMessage("Die Einladung wurde erfolgreich erstellt.", "Erstellt.")
                const vm = new Vue()
                vm.$bvModal.msgBoxOk(`${process.env.VUE_APP_MAIN_URL}/Registrieren/${response.data.data.code}`, {
                    title: 'Einladungslink',
                    autoHideDelay: 5000,
                    okTitle: 'Okay',
                    centered: true
                })
                    .then(() => {
                        commit('clearUser')
                        router.push('/Benutzer')
                    })
            })
            .catch(() => {
                helpers.handleWarningMessage("Beim Erstellen der Einladung ist etwas schief gelaufen.")
            })
    },
    getInvitation({commit}, registerKey) {
        axios.get(process.env.VUE_APP_API_URL + '/invitation/' + registerKey)
            .then((response) => {
                commit('setInvitation', response.data.data)
            })
    },
    register({commit}, {key, password}) {
        commit('none')
        axios.post(process.env.VUE_APP_API_URL + '/user', {
            code: key,
            password,
            password_confirmation: password
        })
            .then(() => {
                helpers.handleSuccessMessage("Sie wurden erfolgreich registriert.")
                router.push('/')
            })
            .catch(() => {
                helpers.handleWarningMessage("Etwas ist schief gelaufen.")
            })
    }
}
